import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import {Toast} from 'vant'
import {isWeixin, weChatAuthorization, getCookie, appid, setCookie, getQueryString} from '../assets/common/js/config'

Vue.use(Toast)

// 自建axios示例
var customRequestAjax = axios.create({
  method: 'get', // 默认是 get
  baseURL: 'https://gxbprep.xlmsxs.com/api',
  timeout: 30000
})

// token: b24vxLk284D0QSyfzxne67jIeslkhtoatK105   000ckys000D0Zo0fvxGdaxIMBtlCIYckys000  b24qrOI284D0Q65n9xnG3fuGfsmMnUoatK105

// 添加请求拦截器
customRequestAjax.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // console.log('wxToken', getCookie('wxmalltoken'))
  // if (getCookie('wxmalltoken')) {
  if (config.method === 'post') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = {
      ...config.data,
      'tn': new Date().getTime(),
      'token': appid
    }
    config.data = qs.stringify(config.data)
  } else if (config.method === 'get') {
    config.params = {
      'tn': new Date().getTime(),
      'token': appid,
      ...config.params
    }
  }
  // } else {
  //   // weChatAuthorization()
  // }
  console.log(config)
  return config
}, (error) => {
  // 对请求错误做些什么
  // Toast.clear()
  console.log(error)
  return Promise.reject(error)
})

// 添加响应拦截器
customRequestAjax.interceptors.response.use(function (res) {
  // 对响应数据做点什么
  // Toast.clear()
  console.log(res)
  if(res.data.code == 5002){
    setCookie('wxmalltoken','')
    window.location = '/login'
  }

  if (res.data.code != 200 && res.data.code != 2000 && res.data.code != 5002) {
    console.log('res', res)
    if (res.config.data) {
    }
    if (res.data.msg) {
      Toast(res.data.msg)
    } else if (res.data.message) {
      Toast(res.data.message)
    }
  }
  return res
}, function (error) {
  // 对响应错误做点什么
  // Toast.clear()
  // Toast('网络错误')
  return Promise.reject(error)
})

export {
  customRequestAjax
}



// WEBPACK FOOTER //
// ./src/axiosApi/index.js